export const CREATE_PARK_RATE = 'CREATE_PARK_RATE';
export const EDIT_PARK_RATE = 'EDIT_PARK_RATE';
export const SHOW_PARKING_SPACE_NAME = 'SHOW_PARKING_SPACE_NAME';
export const PARKING_SPACE_NAME_SUCCESS = 'PARKING_SPACE_NAME_SUCCESS';
export const PARKING_SPACE_NAME_ERROR = 'PARKING_SPACE_NAME_ERROR';